// FLAGS: health-data, silent-failure
// Submits Tripetto check-in answers, falling back to the `sessionStorage` draft when the POST fails.
import axios from "axios";
import { apiPaths } from "@src/utils/constants";
import sessionStorageService from "./sessionStorage.service";

// FLAGS: health-data, silent-failure
// A failed submit is answered by writing the answers to `sessionStorage` and returning that write's
// `undefined`, so a caller cannot tell a stored check-in from a lost one. It also posts to a hardcoded
// `"form/form-answers"` outside `apiPaths`, and nothing under `src/` calls it.
export const saveCheckin = async (formModules, formLanguage, answers) => {
  try {
    const { data } = await axios.post("form/form-answers", {
      formModules,
      formLanguage,
      answers,
    });

    sessionStorageService.removeCheckinLocal();
    return data;
  } catch {
    return sessionStorageService.saveCheckinLocal(
      formModules,
      formLanguage,
      answers,
    );
  }
};

// FLAGS: health-data, silent-failure
// The same fallback for the pre-confirmation flow: a rejected POST resolves as though the answers had
// reached the server.
export const saveUnconfirmedCheckin = async (
  email,
  unconfirmedDataId,
  formModules,
  formLanguage,
  answers,
) => {
  try {
    const { data } = await axios.post(
      apiPaths.setTripettoUnconfirmedFormAnswers,
      {
        email,
        unconfirmedDataId,
        formModules,
        formLanguage,
        answers,
      },
    );
    sessionStorageService.removeCheckinLocal();
    return data;
  } catch {
    return sessionStorageService.saveCheckinLocal(
      formModules,
      formLanguage,
      answers,
    );
  }
};
